
export default function About() {
  return (
    <section id="profil" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">Profil Madrasah</h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Institusi pendidikan Islam yang komited melahirkan generasi Qurani yang cemerlang
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <div className="rounded-2xl shadow-2xl overflow-hidden w-full aspect-video">
              <iframe 
                width="100%" 
                height="100%" 
                src="https://www.youtube.com/embed/5fqV4tPrRiE" 
                title="Video Profil Madrasah"
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          </div>
          
          <div>
            <h3 className="text-3xl font-bold text-emerald-900 mb-6">Pengenalan Madrasah</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Madrasah Tahfiz Al Quran Zawiyah Darul Madad ditubuhkan secara rasminya pada 25 Oktober 2014M bersamaan 1 Muharram 1436H.
            </p>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Terletak di alamat Lot 3945, Kampung Sagil Parit 1, 84900 Tangkak Johor dengan bilangan pelajar sekitar hampir 100 orang termasuk kakitangan pengurusan dan guru.
            </p>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Madrasah ini diasaskan oleh Al Fadhil Ustaz Hj Taufik Bin Khamis @ Maharan bersama Ahli Badan Kebajikan Zawiyah Johor. Didaftarkan di bawah Enakmen Pengawalan Sekolah-Sekolah Agama Islam 1991 sebagai Madrasah Tahfiz Swasta Pendidikan Islam Johor dengan nombor pendaftaran MTS/TGK/008.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-full flex-shrink-0">
                  <i className="ri-eye-line text-2xl text-emerald-700"></i>
                </div>
                <div>
                  <h4 className="font-bold text-emerald-900 mb-2">Visi</h4>
                  <p className="text-gray-700">Menyediakan pusat pengajian ilmu dan tahfiz Al-Quran yang selesa, lengkap dan sesuai dengan mengimbangi arus kemajuan moden disamping mengekalkan kualiti tarbiah dan pembelajaran</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-full flex-shrink-0">
                  <i className="ri-target-line text-2xl text-emerald-700"></i>
                </div>
                <div>
                  <h4 className="font-bold text-emerald-900 mb-2">Misi</h4>
                  <p className="text-gray-700">Melahirkan setiap individu pelajar dapat mengambil sepenuhnya manfaat dan faedah untuk diri serta mampu mengembangkan ilmu agama yang diperolehi tersebut kepada masyarakat Islam khususnya bagi kebaikan dunia dan akhirat</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 p-8 rounded-2xl">
            <h3 className="text-2xl font-bold text-emerald-900 mb-6">Objektif Madrasah</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-emerald-600 mt-1"></i>
                <p className="text-gray-700">Melahirkan generasi Al Quran yang cemerlang untuk kebahagaian didunia dan di akhirat</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-emerald-600 mt-1"></i>
                <p className="text-gray-700">Menerapkan dan mengamalkan nilai-nilai murni kepada Ibu, Bapa, Guru dan Masyarakat</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-emerald-600 mt-1"></i>
                <p className="text-gray-700">Membudayakan Al Quran dalam kehidupan seharian</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-emerald-600 mt-1"></i>
                <p className="text-gray-700">Melampirkan insan yang seimbang antara mengejar dunia dan beramal untuk akhirat</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 p-8 rounded-2xl">
            <h3 className="text-2xl font-bold text-emerald-900 mb-6">Statistik Pelajar</h3>
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-gray-700">Kelas Tahsin</span>
                <span className="font-bold text-emerald-700">11 orang</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-700">Kelas Tahfiz</span>
                <span className="font-bold text-emerald-700">38 orang</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-700">Kelas Syahadah</span>
                <span className="font-bold text-emerald-700">10 orang</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-700">Kelas Kitab</span>
                <span className="font-bold text-emerald-700">12 orang</span>
              </div>
              <hr className="border-emerald-200 my-4" />
              <div className="flex justify-between items-center text-lg font-bold">
                <span className="text-emerald-900">Jumlah Keseluruhan</span>
                <span className="text-emerald-700">71 orang</span>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-emerald-900 rounded-2xl p-8 md:p-12 text-white mb-16">
          <h3 className="text-3xl font-bold mb-8 text-center">Ikrar Madrasah</h3>
          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-xl">
            <p className="text-emerald-100 text-lg leading-relaxed mb-4 text-center italic">
              "Kami pelajar Madrasah Tahfiz Al Quran Zawiyah Darul Madad, Berjanji dan Berikrar akan:"
            </p>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <i className="ri-star-line text-yellow-400 mt-1"></i>
                  <p className="text-emerald-100">Mentaati Allah Dan Rasul</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-star-line text-yellow-400 mt-1"></i>
                  <p className="text-emerald-100">Menyakini Rukun Iman dan Beramal dengan Rukun Islam</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-star-line text-yellow-400 mt-1"></i>
                  <p className="text-emerald-100">Mematuhi segala peraturan dan displin Madrasah</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-star-line text-yellow-400 mt-1"></i>
                  <p className="text-emerald-100">Menghormati segala arahan dan pimpinan Mudir dan Guru</p>
                </div>
              </div>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <i className="ri-star-line text-yellow-400 mt-1"></i>
                  <p className="text-emerald-100">Berazam menjadi insan berbudaya ilmu, beriman dan bertaqwa</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-star-line text-yellow-400 mt-1"></i>
                  <p className="text-emerald-100">Bersedia menerima nasihat, teguran dalam bimbingan</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-star-line text-yellow-400 mt-1"></i>
                  <p className="text-emerald-100">Berusaha memajukan diri untuk sentiasa proaktif</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-star-line text-yellow-400 mt-1"></i>
                  <p className="text-emerald-100">Berjanji berpegang teguh dengan Al Quran dan As Sunnah</p>
                </div>
              </div>
            </div>
            <div className="mt-6 text-center">
              <p className="text-yellow-400 font-bold text-lg">
                "GENERASI AL QURAN CEMERLANG, MEMBAWA KEBAHAGIAAN DUNIA DAN AKHIRAT"
              </p>
            </div>
          </div>
        </div>

        <div className="bg-emerald-900 rounded-2xl p-8 md:p-12 text-white">
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <h3 className="text-3xl font-bold mb-6">Pengasas & Pengetua Madrasah</h3>
              
              <div className="flex flex-col md:flex-row items-start gap-6 mb-6">
                <img 
                  src="https://static.readdy.ai/image/3294a4af19582454411e375cbd1c78be/e1fc8d4a970716bd1e7fdf751f220a86.jpeg"
                  alt="Ustaz Taufik bin Hj Khamis"
                  className="w-32 h-32 rounded-full object-cover object-top border-4 border-yellow-500 flex-shrink-0"
                />
                <div className="flex-1">
                  <h4 className="text-2xl font-bold text-yellow-400 mb-2">TAUFIK BIN KHAMIS @ MAHARAN</h4>
                  <div className="text-emerald-200 space-y-1 mb-4">
                    <p><strong>No. KP:</strong> 830107-01-5089</p>
                    <p><strong>Alamat:</strong> Lot 3671, Lorong Cempedak, Kampung Sinaran Baru, 81300 Skudai, Johor</p>
                    <p><strong>Status:</strong> Berkahwin</p>
                    <p><strong>Telefon:</strong> +60 19-733 4434</p>
                    <p><strong>Email:</strong> alfateh.bkz2012@gmail.com</p>
                  </div>
                  <div className="text-emerald-100 leading-relaxed">
                    <p className="mb-3">
                      Mudir (Pengetua) Madrasah Tahfiz Al Quran Zawiyah Darul Madad yang berpengalaman luas dalam bidang pendidikan Islam dan tahfiz Al-Quran.
                    </p>
                  </div>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
                  <h5 className="text-lg font-bold text-yellow-400 mb-3 flex items-center gap-2">
                    <i className="ri-graduation-cap-line"></i>
                    Latar Belakang Pendidikan
                  </h5>
                  <div className="text-emerald-100 text-sm space-y-2">
                    <div>
                      <p className="font-semibold">Sekolah Kebangsaan Kampung Maju Jaya</p>
                      <p className="text-xs text-emerald-200">2 Disember 1989 - 27 Oktober 1995, Skudai Johor</p>
                    </div>
                    <div>
                      <p className="font-semibold">SMK Sri Rahmat</p>
                      <p className="text-xs text-emerald-200">4 Disember 1995 - 19 November 1998, Johor Bahru</p>
                    </div>
                    <div>
                      <p className="font-semibold">SM Teknik Batu Pahat</p>
                      <p className="text-xs text-emerald-200">15 Mac 1999 - 31 Disember 2000, Kimpalan & Fabrikasi Logam</p>
                    </div>
                    <div>
                      <p className="font-semibold">Darul Mustofa Lid Dirasat Islamiah</p>
                      <p className="text-xs text-emerald-200">Pengajian Islam, Yaman</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
                  <h5 className="text-lg font-bold text-yellow-400 mb-3 flex items-center gap-2">
                    <i className="ri-briefcase-line"></i>
                    Pengalaman Mengajar
                  </h5>
                  <div className="text-emerald-100 text-sm space-y-2">
                    <p>• Guru Tahfiz SKPK Princess Elizabeth JB</p>
                    <p>• Guru Takmir di 6 Masjid & Surau</p>
                    <p>• Imam Masjid Kampung Melayu Majidee</p>
                    <p>• Mudir Madrasah Tahfiz Zawiyah Darul Madad</p>
                  </div>
                </div>
              </div>

              <div className="mt-6 bg-white/5 p-4 rounded-xl">
                <h5 className="text-lg font-bold text-yellow-400 mb-2">Masjid & Surau Yang Pernah Berkhidmat:</h5>
                <div className="grid md:grid-cols-2 gap-2 text-emerald-100 text-sm">
                  <p>• Surau Al-Falah Simpang 5 Darat</p>
                  <p>• Masjid Sungai Jaya, Bukit Gambir</p>
                  <p>• Masjid Al Muttaqin, Kg Hujung Tambak</p>
                  <p>• Surau As-Syakirin, Tmn BDR Bukit Gambir</p>
                  <p>• Masjid Jamek Pekan Gersik</p>
                  <p>• Masjid Kampung Melayu Majidee</p>
                </div>
              </div>
            </div>
            
            <div className="grid grid-cols-2 lg:grid-cols-1 gap-4">
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl text-center">
                <div className="text-3xl font-bold text-yellow-400 mb-2">25+</div>
                <div className="text-emerald-100 text-sm">Tahun Pengalaman Mengajar</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl text-center">
                <div className="text-3xl font-bold text-yellow-400 mb-2">6+</div>
                <div className="text-emerald-100 text-sm">Masjid & Surau Berkhidmat</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl text-center">
                <div className="text-3xl font-bold text-yellow-400 mb-2">10+</div>
                <div className="text-emerald-100 text-sm">Tahun Memimpin Madrasah</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl text-center">
                <div className="text-3xl font-bold text-yellow-400 mb-2">100+</div>
                <div className="text-emerald-100 text-sm">Pelajar Dibimbing</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}